import AboutPage from '_components/composed/pages/AboutPage';

export default function About() {
  return <AboutPage />;
}
